const homeProduct =
[
    {
        id: 1,
        Name: 'product1',
        price: '26',
        image: "./images/p1.webp",
        cat: 'tv',
        type: 'new'
    },
    {
        id: 2,
        Name: 'product2',
        price: '96',
        image:"./images/p2.webp" ,
        cat: 'laptop',
        type: 'new',
    },
    {
        id: 3,
        Name: 'product3',
        price: '236',
        image: "./images/p3.webp",
        cat: 'watch',
        type: 'new',
    },
    {
        id: 4,
        Name: 'product4',
        price: '636',
        image:"./images/p4.webp",
        cat: 'laptop',
        type: 'new',
    },
    {
        id: 5,
        Name: 'product5',
        price: '98',
        image: "./images/p5.webp",
        cat: 'speaker',
        type: 'featured',
    },
    {
        id: 6,
        Name: 'product6',
        price: '59',
        image: "./images/p6.webp",
        cat: 'electronics',
        type: 'featured',
    },
    {
        id: 7,
        Name: 'product7',
        price: '956',
        image: "./images/p7.webp",
        cat: 'headphone',
        type: 'featured',
    },
    {
        id: 8,
        Name: 'product8',
        price: '389',
        image: "./images/p8.webp",
        cat: 'electronics',
        type: 'featured',
    },
    {
        id: 9,
        Name: 'product9',
        price: '67',
        image: "./images/p9.jpg",
        cat: 'phone',
        type: 'top',
    },
    {
        id: 10,
        Name: 'product10',
        price: '76',
        image: "./images/p10.jpg",
        cat: 'speaker',
        type: 'top',
    },
    {
        id: 11,
        Name: 'product11',
        price: '87',
        image: "./images/p11.jpg",
        cat: 'speaker',
        type: 'top',
    },
    {
        id: 12,
        Name: 'product12',
        image: "./images/p12.jpg",
        price: '98',
        cat: 'speaker',
        type: 'top',
    },
]
export default homeProduct;